export const countRequests = (requests) => {
    let c = requests.length;

    requests.forEach((request) => {
        if (request.children) {
            c = c + countRequests(request.children);
        }
    });

    return c;
};
